"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("../../control-components/ui-components/Button"));

var _reactModal = _interopRequireDefault(require("../../components/reactModal"));

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _EventCalendarRow = _interopRequireDefault(require("../widget-events-calendar/EventCalendarRow"));

var _Checkmark = _interopRequireDefault(require("@insided/shared/icons/Checkmark"));

var _Content = _interopRequireDefault(require("../common/Content"));

var _FeaturedTopicsListAsRecommended = _interopRequireDefault(require("./FeaturedTopicsListAsRecommended"));

var _Share = _interopRequireWildcard(require("../../control-components/ui-components/Share"));

var _classnames = _interopRequireDefault(require("classnames"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _CalendarLinks = _interopRequireDefault(require("@insided/deprecated-preact-components/Event/CalendarLinks"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var types = [(0, _preact.h)(_phrase.default, {
  p: "events.attending",
  m: "Forum",
  key: "attending"
}), (0, _preact.h)(_phrase.default, {
  p: "events.not.attending",
  m: "Forum",
  key: "not-attending"
})];

var statusMapping = function statusMapping(attending) {
  return attending ? types[0] : types[1];
};

var EventHeader = function EventHeader(_ref) {
  var _getInsidedData;

  var title = _ref.title,
      scheduleAt = _ref.scheduleAt,
      startAt = _ref.startAt,
      isOpenForSignUp = _ref.isOpenForSignUp,
      image = _ref.image,
      type = _ref.type,
      confirmationMessage = _ref.confirmationMessage,
      isEventEngagementEnabled = _ref.isEventEngagementEnabled,
      isAttendee = _ref.isAttendee,
      isLoadingAttend = _ref.isLoadingAttend,
      showModalAttendConfirmation = _ref.showModalAttendConfirmation,
      onCloseModalAttendConfirmation = _ref.onCloseModalAttendConfirmation,
      showModalEditRsvp = _ref.showModalEditRsvp,
      rsvpStatus = _ref.rsvpStatus,
      onAttend = _ref.onAttend,
      onEditRsvp = _ref.onEditRsvp,
      onCloseModalEditRsvp = _ref.onCloseModalEditRsvp,
      onUpdateRsvp = _ref.onUpdateRsvp,
      onAttendanceChanged = _ref.onAttendanceChanged,
      isLoadingConfirm = _ref.isLoadingConfirm,
      isPastEvent = _ref.isPastEvent,
      isLoadingUpdate = _ref.isLoadingUpdate,
      eventId = _ref.eventId,
      eventContent = _ref.eventContent,
      externalRegistrationUrl = _ref.externalRegistrationUrl,
      externalRegistrationUrlLabel = _ref.externalRegistrationUrlLabel,
      appleCalendarICSDownloader = _ref.appleCalendarICSDownloader,
      googleCalendarLink = _ref.googleCalendarLink,
      outlookCalendarLink = _ref.outlookCalendarLink,
      office365CalendarLink = _ref.office365CalendarLink;
  var isRegisteredUser = typeof window === 'undefined' ? false : !!((_getInsidedData = (0, _insidedDataStorage.getInsidedData)('user')) !== null && _getInsidedData !== void 0 && _getInsidedData.userid);
  var isExternalRegistrationEnabled = !!(externalRegistrationUrl && externalRegistrationUrlLabel);

  var externalRegistrationUrlClick = function externalRegistrationUrlClick() {
    if (typeof window === 'undefined') return;
    window.open(externalRegistrationUrl, '_blank');
  };

  var socialShare = (0, _preact.h)(_Share.default, {
    renderAsButton: true,
    buttons: [{
      type: _Share.ShareButtonType.LINKEDIN,
      title: title,
      linkTitle: 'linkedin',
      content: eventContent
    }, {
      type: _Share.ShareButtonType.FACEBOOK,
      title: title,
      linkTitle: 'facebook',
      content: eventContent
    }, {
      type: _Share.ShareButtonType.TWITTER,
      title: title,
      linkTitle: 'twitter',
      content: eventContent
    }, {
      type: _Share.ShareButtonType.WHATSAPP,
      title: title,
      linkTitle: 'whatsapp',
      content: eventContent
    }]
  });
  var attendeeStatusMapping = {
    attend: (0, _preact.h)("div", {
      className: "event-cta-wrapper"
    }, (0, _preact.h)(_Button.default, {
      class: "btn--cta btn--event event__sign-up qa-event-sign-up",
      onClick: function onClick() {
        return onAttend();
      },
      loading: isRegisteredUser ? isLoadingAttend : false
    }, (0, _preact.h)(_phrase.default, {
      p: "events.attend",
      m: "Forum"
    })), socialShare),
    Attending: (0, _preact.h)("div", {
      className: "event-attending-wrapper"
    }, (0, _preact.h)("div", {
      className: "event-cta-wrapper"
    }, (0, _preact.h)("div", {
      className: (0, _classnames.default)('event__attending', 'btn--event', 'qa-event-attending')
    }, (0, _preact.h)(_Checkmark.default, {
      className: "icon-checkmark"
    }), (0, _preact.h)("span", {
      className: "event__signed-up-text"
    }, (0, _preact.h)(_phrase.default, {
      p: "events.attending",
      m: "Forum"
    }))), socialShare), (0, _preact.h)("div", null, (0, _preact.h)("button", {
      className: (0, _classnames.default)('event__edit-rsvp', 'btn--event', 'qa-event-edit-rsvp'),
      onClick: function onClick() {
        return onEditRsvp();
      }
    }, (0, _preact.h)(_phrase.default, {
      p: "events.rsvp.edit",
      m: "Forum"
    })))),
    attended: (0, _preact.h)("div", {
      className: "event-cta-wrapper"
    }, (0, _preact.h)(EventAttendedButton, null), socialShare),
    event_ended: (0, _preact.h)("div", {
      className: "event-cta-wrapper"
    }, (0, _preact.h)("div", {
      className: (0, _classnames.default)('btn--event', 'event__ended', 'qa-event-ended')
    }, (0, _preact.h)(_phrase.default, {
      p: "events.ended",
      m: "Forum"
    })), socialShare),
    external_rsvp: (0, _preact.h)("div", {
      className: "event-cta-wrapper"
    }, (0, _preact.h)(_Button.default, {
      class: "btn--cta btn--event event__sign-up qa-event-sign-up",
      onClick: function onClick() {
        return externalRegistrationUrlClick();
      },
      loading: isRegisteredUser ? isLoadingAttend : false
    }, externalRegistrationUrlLabel !== null && externalRegistrationUrlLabel !== void 0 ? externalRegistrationUrlLabel : 'Register'), socialShare)
  };
  var attendeeStatus = checkAttendeeStatus({
    isOpenForSignUp: isOpenForSignUp,
    isAttendee: isAttendee,
    isExternalRegistrationEnabled: isExternalRegistrationEnabled,
    isPastEvent: isPastEvent
  });
  return (0, _preact.h)("div", {
    className: "event-header-container ".concat(image ? '' : 'event-header-container-full-width')
  }, (0, _preact.h)("div", {
    className: "event-header-wrapper"
  }, (0, _preact.h)("div", {
    className: "event-header__title"
  }, type && (0, _preact.h)("span", {
    className: "event-pill__type pill pill--uppercase qa-event-type-pill ".concat(isOpenForSignUp ? '' : 'event-pill__past')
  }, type), (0, _preact.h)("div", {
    className: "event__date ".concat(isOpenForSignUp ? '' : 'event__date_past')
  }, scheduleAt), (0, _preact.h)("h1", {
    className: "event__title"
  }, title)), isEventEngagementEnabled && (0, _preact.h)("div", {
    className: "event-engagement-wrapper"
  }, attendeeStatusMapping[attendeeStatus], (0, _preact.h)(ConfirmAttendModal, {
    eventId: eventId,
    showModalAttendConfirmation: showModalAttendConfirmation,
    onCloseModalAttendConfirmation: onCloseModalAttendConfirmation,
    onAttend: onAttend,
    title: title,
    startAt: startAt,
    type: type,
    confirmationMessage: confirmationMessage,
    modalTitle: (0, _preact.h)(_phrase.default, {
      p: "events.attending.you",
      m: "Forum"
    }),
    buttonText: (0, _preact.h)(_phrase.default, {
      p: "events.ok",
      m: "Forum"
    }),
    isLoadingConfirm: isLoadingConfirm,
    googleCalendarLink: googleCalendarLink,
    outlookCalendarLink: outlookCalendarLink,
    office365CalendarLink: office365CalendarLink,
    appleCalendarICSDownloader: appleCalendarICSDownloader
  }), (0, _preact.h)(UpdateRsvpModal, {
    onEditRsvp: onEditRsvp,
    showModalEditRsvp: showModalEditRsvp,
    onCloseModalEditRsvp: onCloseModalEditRsvp,
    onUpdateRsvp: onUpdateRsvp,
    rsvpStatus: rsvpStatus,
    onAttendanceChanged: onAttendanceChanged,
    modalTitle: (0, _preact.h)(_phrase.default, {
      p: "events.rsvp.update.title",
      m: "Forum"
    }),
    buttonText: (0, _preact.h)(_phrase.default, {
      p: "events.rsvp.update",
      m: "Forum"
    }),
    isLoadingUpdate: isLoadingUpdate
  }))), image && (0, _preact.h)("div", {
    role: "img",
    "aria-label": title,
    className: "event__image",
    style: {
      backgroundImage: "url(".concat(image, ")")
    }
  }));
};

var ConfirmAttendModal = function ConfirmAttendModal(_ref2) {
  var modalTitle = _ref2.modalTitle,
      buttonText = _ref2.buttonText,
      showModalAttendConfirmation = _ref2.showModalAttendConfirmation,
      onCloseModalAttendConfirmation = _ref2.onCloseModalAttendConfirmation,
      title = _ref2.title,
      startAt = _ref2.startAt,
      type = _ref2.type,
      confirmationMessage = _ref2.confirmationMessage,
      isLoadingConfirm = _ref2.isLoadingConfirm,
      eventId = _ref2.eventId,
      appleCalendarICSDownloader = _ref2.appleCalendarICSDownloader,
      googleCalendarLink = _ref2.googleCalendarLink,
      outlookCalendarLink = _ref2.outlookCalendarLink,
      office365CalendarLink = _ref2.office365CalendarLink;
  return (0, _preact.h)("div", {
    className: "confirmation-modal-wrapper qa-confirmation-modal"
  }, (0, _preact.h)(_reactModal.default, {
    isOpen: showModalAttendConfirmation,
    onClose: onCloseModalAttendConfirmation
  }, (0, _preact.h)("div", {
    className: "confirmation-modal-title"
  }, (0, _preact.h)("h3", null, modalTitle)), (0, _preact.h)("div", {
    className: "confirmation-modal-body"
  }, (0, _preact.h)(_EventCalendarRow.default, {
    title: title,
    startAt: startAt,
    type: type
  }), confirmationMessage && (0, _preact.h)("div", {
    className: "confirmation-modal-message"
  }, (0, _preact.h)(_Content.default, {
    content: confirmationMessage || '',
    className: "event__confirmation-message"
  })), (0, _preact.h)(_CalendarLinks.default, {
    googleCalendarLink: googleCalendarLink,
    outlookCalendarLink: outlookCalendarLink,
    office365CalendarLink: office365CalendarLink,
    appleCalendarICSDownloader: appleCalendarICSDownloader
  }), (0, _preact.h)(_FeaturedTopicsListAsRecommended.default, {
    eventId: eventId
  }), (0, _preact.h)("div", {
    className: "confirmation-modal-button"
  }, (0, _preact.h)(_Button.default, {
    class: "btn--confirm event__attend-confirmation qa-event-attend-confirmation",
    onClick: function onClick() {
      return onCloseModalAttendConfirmation();
    },
    type: "submit",
    loading: isLoadingConfirm
  }, buttonText)))));
};

var UpdateRsvpModal = function UpdateRsvpModal(_ref3) {
  var modalTitle = _ref3.modalTitle,
      buttonText = _ref3.buttonText,
      showModalEditRsvp = _ref3.showModalEditRsvp,
      onCloseModalEditRsvp = _ref3.onCloseModalEditRsvp,
      onUpdateRsvp = _ref3.onUpdateRsvp,
      rsvpStatus = _ref3.rsvpStatus,
      onAttendanceChanged = _ref3.onAttendanceChanged,
      isLoadingUpdate = _ref3.isLoadingUpdate;
  return (0, _preact.h)("div", {
    className: "edit-rsvp-modal-wrapper"
  }, (0, _preact.h)(_reactModal.default, {
    isOpen: showModalEditRsvp,
    onClose: onCloseModalEditRsvp
  }, (0, _preact.h)("div", {
    className: "modal-title"
  }, (0, _preact.h)("h3", null, modalTitle), (0, _preact.h)("div", null, (0, _preact.h)("form", {
    className: "edit-rsvp__form",
    onSubmit: function onSubmit(e) {
      onUpdateRsvp(e);
    }
  }, (0, _preact.h)(_RadioInputGroup.default, {
    required: true,
    name: "type",
    options: types,
    value: statusMapping(rsvpStatus),
    onChange: function onChange(value) {
      return onAttendanceChanged(value === types[0]);
    }
  }), (0, _preact.h)(_Button.default, {
    class: "btn--event event__update-rsvp qa-event-update-rsvp",
    loading: isLoadingUpdate,
    type: "submit"
  }, buttonText))))));
};

var checkAttendeeStatus = function checkAttendeeStatus(_ref4) {
  var isOpenForSignUp = _ref4.isOpenForSignUp,
      isAttendee = _ref4.isAttendee,
      isExternalRegistrationEnabled = _ref4.isExternalRegistrationEnabled,
      isPastEvent = _ref4.isPastEvent;

  if (isExternalRegistrationEnabled && !isPastEvent) {
    return 'external_rsvp';
  }

  if (isOpenForSignUp) {
    return isAttendee ? 'Attending' : 'attend';
  }

  return isAttendee ? 'attended' : 'event_ended';
};

var EventAttendedButton = function EventAttendedButton() {
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('btn--event', 'event__attended', 'event__signed-up-past', 'qa-event-attended')
  }, (0, _preact.h)(_Checkmark.default, {
    className: "icon-checkmark"
  }), (0, _preact.h)("span", {
    className: "event__attended-text"
  }, (0, _preact.h)(_phrase.default, {
    p: "events.attended",
    m: "Forum"
  })));
};

var _default = EventHeader;
exports.default = _default;